<template>
  <div class="modal report-modal">
    <div class="overlay" @click="closeNotification"></div>
    <div class="wrapper">
      <div class="container">
        <div class="overflow">
          <img
            class="close"
            @click="closeNotification"
            src="./../images/close.svg"
          />
          <div class="title small">
            {{ notificationText }}
          </div>
          <div class="buttons" v-if="notificationOk">
            <button class="button colored" @click="closeNotification">
              OK
            </button>
            <!--            <button class="button red" @click="closeNotification">CLOSE</button>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ReportModal",
  props: [],
  data: function () {
    return {};
  },
  methods: {
    ...mapActions("app", ["closeNotification"]),
  },
  computed: {
    ...mapGetters("app", ["notificationText", "notificationOk"]),
  },
};
</script>
